import { RatioBox } from '@/components/Atoms/RatioBox/RatioBox';
import { ratios } from '@/styles/layout';

/**
 * A 16:9 Vimeo player.
 */
export const VimeoPlayer = (props: IVimeoPlayerProps) => {
    const url = `https://player.vimeo.com/video/${props.videoId}?badge=0&byline=0&color=00bae3&title=0&portrait=0`;
    return (
        <RatioBox ratio={ratios.media}>
            <iframe src={url} width="100%" height="100%" allowFullScreen={true} allow="fullscreen" />
        </RatioBox>
    );
};

interface IVimeoPlayerProps {
    /** ID of the video */
    videoId: string;
}
